<template>
  <div v-if="currentDrawer != {}" style="width: 100%; height: 100%;" :key="listKey">
    <el-row style="height: 100%; display: flex; flex-direction: column;">
      <el-row style="padding: 10px; background-color: rgb(238, 241, 246); 
        display: flex; flex-direction: row-reverse; justify-content: end; min-height: 48px; align-items: center;">
        <!-- <strong style="padding-left: 30px; font-size: 16px; padding-right: 30px;">
          Filters
        </strong> -->
        <div style="padding-right: 15px;">
          <el-switch
            v-model="showAll"
            active-text="Show all"
            inactive-text="Show one for each HOW type">
          </el-switch>
          <el-switch
            v-model="showDetail"
            active-text="Show detail"
            inactive-text="Hide detail"
            style="padding-left: 30px;">
          </el-switch>
        </div>
      </el-row>
      <div style="display: flex; justify-content: space-between; padding: 30px; gap: 10px; padding-top: 10px; padding-bottom: 10px; padding-right: 10px;">
        <div style="display: flex; flex-direction: column; width: 22%;">
          <div style="display: flex; align-items: center; gap: 10px; padding-bottom: 10px;">
            <el-tag color="rgb(11,175,169)" effect="dark" class="left-tag" size="large">
              <strong>WHY</strong> apply?
            </el-tag>
            <el-tag color="rgba(136,205,203,0.5)" style="color: rgb(0,100,96);"
              class="right-tag" size="large"> {{ translate(currentDrawer.explain.why) }} </el-tag>
            <!-- <img :src="require(`../assets/SVG/${eng2chn[currentDrawer.explain.why]}.svg`)"
              style="width: 30px; height: 30px;" /> -->
          </div>
          <div style="display: flex; align-items: center; flex: 1;">
            <img :src="require(`../assets/SVG/${eng2chn[currentDrawer.explain.why]}.svg`)"
              style="width: 60px; height: 60px; float: left; margin-right: 10px;" />
            <span style="font-size: 16px;"> {{ currentDrawer.explain['why_explained'] }}</span>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; width: 22%;">
          <div style="display: flex; align-items: center; gap: 10px; padding-bottom: 10px;">
            <el-tag color="rgb(118,118,251)" effect="dark" class="left-tag" size="large">
              <strong>WHAT</strong> data?
            </el-tag>
            <el-tag color="rgba(168,168,255,0.5)" style="color: rgb(54,54,154);"
              class="right-tag" size="large"> {{ translate(currentDrawer.explain.what) }} </el-tag>
            <!-- <img :src="require(`../assets/SVG/${eng2chn[currentDrawer.explain.what]}.svg`)"
              style="width: 30px; height: 30px;" /> -->
          </div>
          <div style="flex: 1; display: flex; align-items: center;">
            <img :src="require(`../assets/SVG/${eng2chn[currentDrawer.explain.what]}.svg`)"
              style="width: 60px; height: 60px; float: left; margin-right: 10px;" />
            <span style="font-size: 16px;"> {{ currentDrawer.explain['what_explained'] }}</span>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; flex: 1;">
          <div style="display: flex; align-items: center; gap: 20px; padding-bottom: 10px;">
            <el-tag color="rgb(96,140,244)" effect="dark" class="left-tag" size="large">
              <strong>HOW</strong> to establish?
            </el-tag>
            <span style="font-size: 17px">
              Establish visual metaphors with mappings by:
            </span>
          </div>
          <div style="display: flex; justify-content: space-around; align-items: end; min-height: 0;">
            <div v-for="how in howDist" :key="how.id"
              style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
              @click="howSelect = howSelect!==how.how?how.how:''; updateShow();" >
              <img v-show="howSelect===''||howSelect===how.how"
                src="../assets/bulb/bulb.svg"
                :style="{ width: scaleWidth(how.cnt)+'px'}"/>
              <img v-show="howSelect!==''&&howSelect!==how.how"
                src="../assets/bulb/half-circle.svg"
                style="opacity: 0.5;"
                :style="{ width: scaleWidth(how.cnt)*0.6+'px'}"/>
              <button class="how-button"
                :style="{ 'background-image': 'url(' + require(`../assets/SVG/${how.how}.svg`) + ')', 'border-color': howSelect===''||how.how===howSelect? 'rgb(230,162,60)': ''}"
                />
              <img src="../assets/bulb/under.svg" 
                style="width: 15px; margin-top: 0;"
                :style="{opacity: howSelect===''||how.how===howSelect?1:0.5}"/>
              <!-- <span style="font-size: 16px; line-height: 20px;">{{ chn2eng[how.how] }}</span> -->
              <el-tag class="how-tag" size="small" style="margin-top: 5px; font-size: 16px;"
                :type="howSelect===''||how.how===howSelect?'':'info'"> 
                {{ translate(how.how,0) }} 
              </el-tag>
            </div>
          </div>
        </div>
      </div>
      <!-- ImageExplained 组件 -->
      <div v-if="showDetail" ref="resContainer" style="padding-left: 20px; flex: 1;  overflow-y: auto;">
        <ImageExplained @recommend="recommend" @starChanged="starChanged"
          v-for="card in currentDrawer.allChildren"
          :key="card.name + card.how"
          style="width: 48%; height: 180px; margin: 5px;"
          :style="{ display: card.pageShow ? 'inline-block' : 'none' }"
          :cardInit="card"
        />
      </div>
      <div v-if="!showDetail" ref="resContainer" style="padding-left: 20px; flex: 1;  overflow-y: auto;">
        <ImageSimple @recommend="recommend" @starChanged="starChanged"
          v-for="card in currentDrawer.allChildren"
          :key="card.name + card.how"
          style="width: 220px; height: 260px; margin: 5px;"
          :style="{ display: card.pageShow ? 'inline-block' : 'none' }"
          :cardInit="card"
        />
      </div>
    </el-row>
  </div>
</template>

<style>
  .el-switch__label * {
    font-size: 16px; /* 设置字体大小 */
  }
  .how-button {
    background-size: cover;  /* 确保背景图像覆盖整个按钮 */
    background-repeat: no-repeat; /* 防止背景图像重复 */
    background-position: center; /* 图片居中 */
    border: 3px solid rgb(235,235,235);
    width: 60px;  /* 按钮宽度 */
    height: 60px;  /* 按钮高度 */
    cursor: pointer;  /* 鼠标移上去显示手型 */
    /* background-clip: content-box; */
    background-origin: content-box; /* 背景从内容区域开始 */
    padding: 5px;
    border-radius: 10px;
    background-color: transparent;
  }
</style>

<script>
// import axios from 'axios';
// import * as d3 from 'd3';
import ImageExplained from './ImageExplained.vue';
import ImageSimple from './ImageSimple.vue';
import { chn2eng, eng2chn, translate2chn } from '../utils/defs.js';
export default {
    name: 'Drawers',
    components: {
      ImageExplained,
      ImageSimple
    },
    props: {
      currentDrawer: {
        type: Object,
        default: () => { return {} }
      }
    },
    watch: {
      showDetail: function () {
        this.$refs.resContainer.scrollTop = 0;
      },
      showAll: function () {
        this.updateShow();
      },
      currentDrawer: function () {
        this.$refs.resContainer.scrollTop = 0;
        this.updateHowDist();
        this.updateShow();
      }
    },
    data() {
      return {
        showAll: true,
        showDetail: true,
        howDist: [],
        howSelect: '',
        chn2eng: chn2eng,
        eng2chn: eng2chn,
        listKey: 0,
      }
    },
    computed: {
    },
    methods: {
      translate(name, eng=1) {
        if (eng) return translate2chn(name);
        return translate2chn(this.chn2eng[name]);
      },
      recommend(name, cd) {
        this.$emit('recommend', name, cd);
      },
      starChanged() {
        this.$emit('starChanged');
      },
      updateShow: function () {
        this.$refs.resContainer.scrollTop = 0;
        // console.log(this.showAll, this.howSelect);
        if (!this.showAll) {
          let recList = [];
          for (const cd of this.currentDrawer.allChildren) {
            if (recList.includes(cd.how)) {
              cd.pageShow = false;
            } else {
              cd.pageShow = true;
              recList.push(cd.how);
            }
          }
        } else {
          for (const cd of this.currentDrawer.allChildren) {
            cd.pageShow = true;
          }
        }
        if (this.howSelect.length) {
          for (const cd of this.currentDrawer.allChildren) {
            if (cd.how != this.howSelect) {
              cd.pageShow = false;
            }
          }
        }
        // this.$nextTick(() => {
        //   window.scrollBy(0, 1);  // 滚动1像素
        //   window.scrollBy(0, -1); // 滚回来
        // });
        this.listKey += 1;  // 强制刷新列表
      },
      updateHowDist: function () {
        this.howSelect = '';
        let howCnt = {};
        for (const cd of this.currentDrawer.allChildren) {
          if (howCnt[cd.how]) {
            howCnt[cd.how] += 1;
          } else {
            howCnt[cd.how] = 1;
          }
        }
        let howDist = Object.entries(howCnt).map(([k, v]) => {
          return { how: k, cnt: v };
        });
        howDist.sort((a, b) => b.cnt - a.cnt);
        // add id for each how
        for (let i = 0; i < howDist.length; i++) {
          howDist[i].id = i;
        }
        this.howDist = howDist;
      },
      scaleWidth: function (val) {
        const mini = 25, maxi = 45;
        const dists = this.howDist.map(h => h.cnt);
        const minDist = 0;
        const maxDist = Math.max(40, Math.max(...dists));
        return mini + (maxi - mini) * (val - minDist) / (maxDist - minDist);
      }
    },
    mounted() {
      this.updateHowDist();
      this.updateShow();
    }
  };
</script>